/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { ScrollToTop } from './components/ScrollToTop';
import { GlobalTracking } from './components/GlobalTracking';

import { Home } from './pages/Home';
const ServiceLocationTemplate = lazy(() => import('./pages/ServiceLocationTemplate').then(m => ({ default: m.ServiceLocationTemplate })));
const ServicesHub = lazy(() => import('./pages/ServicesHub').then(m => ({ default: m.ServicesHub })));
const LocationsHub = lazy(() => import('./pages/LocationsHub').then(m => ({ default: m.LocationsHub })));
const RegionHub = lazy(() => import('./pages/RegionHub').then(m => ({ default: m.RegionHub })));
const CityTemplate = lazy(() => import('./pages/CityTemplate').then(m => ({ default: m.CityTemplate })));
const Impressum = lazy(() => import('./pages/Impressum').then(m => ({ default: m.Impressum })));
const Datenschutz = lazy(() => import('./pages/Datenschutz').then(m => ({ default: m.Datenschutz })));
const AGB = lazy(() => import('./pages/AGB').then(m => ({ default: m.AGB })));
const ServiceTemplate = lazy(() => import('./pages/ServiceTemplate').then(m => ({ default: m.ServiceTemplate })));
const UeberUns = lazy(() => import('./pages/UeberUns').then(m => ({ default: m.UeberUns })));
const Preise = lazy(() => import('./pages/Preise').then(m => ({ default: m.Preise })));
const Kontakt = lazy(() => import('./pages/Kontakt').then(m => ({ default: m.Kontakt })));
const SEODashboard = lazy(() => import('./pages/SEODashboard').then(m => ({ default: m.SEODashboard })));
const NotFound = lazy(() => import('./pages/NotFound').then(m => ({ default: m.NotFound })));

const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center bg-brand-black">
    <div className="w-12 h-12 border-4 border-brand-red border-t-transparent rounded-full animate-spin"></div>
  </div>
);

export default function App() {
  return (
    <BrowserRouter>
      <GlobalTracking />
      <ScrollToTop />
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="leistungen" element={<ServicesHub />} />
            <Route path="leistungen/:serviceSlug" element={<ServiceTemplate />} />
            <Route path="standorte" element={<LocationsHub />} />
            <Route path="standorte/:regionSlug" element={<RegionHub />} />
            <Route path="standorte/:regionSlug/:locationSlug" element={<CityTemplate />} />
            <Route path="impressum" element={<Impressum />} />
            <Route path="datenschutz" element={<Datenschutz />} />
            <Route path="agb" element={<AGB />} />
            <Route path="preise" element={<Preise />} />
            <Route path="ueber-uns" element={<UeberUns />} />
            <Route path="karriere" element={<Navigate to="/ueber-uns" replace />} />
            <Route path="kontakt" element={<Kontakt />} />
            <Route path="seo-panel" element={<SEODashboard />} />
            {/* 135+ Pages handled by this programmatic route */}
            <Route path="leistungen/:serviceSlug/:locationSlug" element={<ServiceLocationTemplate />} />
            {/* 404 Page */}
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
